<div *ngIf="hasGoCam">
  <div class="full-view-header">
      <span>GO-CAM pathway
        <span class="model-title" *ngIf="gocams.length == 1">{{currentGoCam()!.title || currentGoCamId}}</span>
        <span classclass="model-select" *ngIf="gocams.length > 1 ">
          <select [(ngModel)]="currentGoCamId" (ngModelChange)="modelChange()" class="go-cam-select">
            <option *ngFor="let gocam of gocams" [ngValue]="gocam.gocam_id">
              {{gocam.title || gocam.gocam_id}}
            </option>
          </select>
        </span>
      </span>
      <span class="large-view"><a routerLink="{{largeViewPath}}">Show larger view ...</a></span>
      <span class="help-link">
      <app-help-link [route]="'/documentation/gocams'" [title]="'GO-CAM documentation'">
      </app-help-link>
    </span>
  </div>

  <div *ngFor="let o of [geneOrTermDetails]">
  <iframe [src]="getIFrameURL()" class="embedded-go-cam-viewer" #gocamiframe>
  </iframe>
  </div>
</div>

<div *ngIf="!hasGoCam && displayName" class="no-go-cams">
  No GO-CAM pathways available for {{displayName}}
</div>
